import { theme } from './theme'
import lightColors from './themas/light'

let colors = {
	...(theme.type === 'dark' ? lightColors : lightColors),
}

export default colors
